// This file is AUTOGENERATED, do not edit it manually!!!

export const taskDetails = {
    actualCompletionDate: 'Факт. дата выполн.: ',
    actualCompletionDateFull: 'Фактическая дата выполнения',
    AutoAssign_Issue: 'Автом. назначать новые проблемы на:',
    AutoAssign_Note: 'Выбранный член проекта будет назначен на каждую созданную активность в этом проекте',
    AutoAssign_Request: 'Автом. назначать новые запросы на:',
    AutoAssign_Task: 'Автом. назначать новые задания на:',
    AutoAssign_Title: 'Автомат. назначение',
    BaselineCapturedFeedback: 'Базовый план проекта был задан. Переключитесь на Гант и выберите параметр «Показать», чтобы посмотреть его.',
    BaselineCaptureLabel: 'Задать базовый план',
    BaselineOverwrite: 'Заменить текущий базовый план?',
    BaselineOverwriteDescription: 'Для данного проекта уже выставлен базовый план. В случае продолжения он будет заменен на новый.',
    BaselineOverwrittenFeedback: 'Базовый план проекта был заменен. Переключитесь на Гант и выберите параметр «Показать», чтобы посмотреть его.',
    BaselineRecaptureLabel: 'Заменить базовый план',
    BaselineSuccess: 'Базовый план успешно сохранен.',
    Billed: 'Оплачена',
    Billing: 'Биллинг',
    BillingSettingsTitle: 'Настройки биллинга',
    BillingTypeNotBillable: 'Неоплачиваемая',
    BillingTypeProjectBillingSettings: 'Настройки биллинга проекта',
    btnNotifications: 'Уведомления',
    BudgetLeft: ' осталось',
    BudgetTotal: ' всего',
    Change: 'изменить',
    Close: 'Закрыть',
    ConfirmStatusDialogTitle: 'Завершить \"{0}\"?',
    CreateInvoice_Title: 'Создать счет',
    DayPluralFormat: '7#{0} день#{0} дня#{0} дней',
    Days: '({0}дн)',
    DeleteActivity: 'Удалить задачу',
    DeleteProject: 'Удалить проект',
    Dependencies_Count: '7#{0} Зависимость#{0} Зависимости#{0} Зависимостей',
    DifferPermissionsMessage: 'указывает на то, что  привилегии текущ. участника проекта отличаются от привилегий, включенных в роль по умолчанию',
    Disable_Dates_Rollup: 'Выключить автопересчет дат',
    Disable_Dates_Rollup_Feedback: 'Автоматический пересчет дат выключен',
    DueIn_Ok: 'до заверш. {0}',
    DueIn_Trouble: 'просроч. на {0}',
    DueIn_Warning: 'срок заверш. сегодня',
    EditRoleAndPermissions: 'Редакт. роль и права',
    Enable_And_Reschedule: 'Включить и пересчитать',
    Enable_Dates_Rollup: 'Включить автопересчет дат',
    Enable_Dates_Rollup_Description: 'Включение этой опции приведет к перерасчету дат проекта.',
    Enable_Dates_Rollup_Feedback: 'Автоматический пересчет дат включен',
    Enable_Dates_Rollup_Title: 'Даты проекта будут рассчитаны заново',
    endDate: 'План. дата оконч.: ',
    endDateFull: 'Планируемая дата окончания',
    endLessThenStartMsg: '\'Дата окончания\' не должна предшествовать \'Дате начала\'',
    estimatedHours: '7# расчетный час# расчетных часа# расчетных часов',
    ExportToMsProject: 'Экспорт в MS Project',
    Fields: '7#{0} поле#{0} поля#{0} полей',
    FillCustomFields: 'Требуется заполнить ещё {0}',
    Follow: 'Следить',
    follow_all_activities_label: 'Следить за всеми активностями',
    hide_checklist_label: 'Спрятать чек-лист',
    HideCustomFields: 'Скрыть дополнительные поля',
    hoursLeft: '7# час остался# часа осталось# часов осталось',
    HoursOf: 'ч из ',
    HtmlField_ReadAll: '... показать полностью',
    ImDoneText: 'Работу выполнил',
    invoice_creation_no_customer_disabled_reason: 'Выберите заказчика, чтобы иметь возможность создавать счет',
    IsMilestone: 'Это веха',
    issue: 'Проблема',
    MarkAsMilestone: 'Пометить вехой',
    MemberPermission_Add: 'Добавлять',
    MemberPermission_Add_For_Someone_Else: 'Добавлять за др. лицо',
    MemberPermission_Add_Own: 'Добавлять собств.',
    MemberPermission_CanEditActualExpenses: 'Редактировать все фактические',
    MemberPermission_CanEditPlannedExpenses: 'Редактировать все плановые',
    MemberPermission_CanLogExpenses: 'Добавлять собств.',
    MemberPermission_CanManageProjectMembers: 'Изменять членов проекта и права',
    MemberPermission_CanManageProjectMembersAndAllocations: 'Изменять членов проекта, права и распределение',
    MemberPermission_CanViewAllExpenses: 'Видеть все',
    MemberPermission_CanViewMembersAndAssignees: 'Просмотр',
    MemberPermission_Delete: 'Удалять',
    MemberPermission_Delete_All: 'Удалять все',
    MemberPermission_Delete_Or_Archive: 'Удалять/Архивировать',
    MemberPermission_Edit: 'Редактировать',
    MemberPermission_Edit_All: 'Редакт. все',
    MemberPermission_Edit_Assigned: 'Редакт. назначенные',
    MemberPermission_Manage_Assigned: 'Изменять назначенных',
    MemberPermission_View_All: 'Видеть все',
    MemberPermission_View_and_Manage: 'Видеть и менять',
    MemberPermission_View_Assigned: 'Видеть назначенные',
    MemberPermissions_ExpensesTitle: 'Расходы:',
    MemberPermissions_MembersAndAssigneesTitle: 'Члены проекта и назначенные:',
    MemberPermissions_TasksTitle: 'Активности:',
    MemberPermissions_ThisProjectTitle: 'Проект:',
    MemberPermissions_TimeEntriesTitle: 'Тайм-логи:',
    Members: '7#{0} Член проекта#{0} Члена  проекта#{0} Членов проекта',
    no_assignee: 'Нет назначения',
    OwnBudget: 'Бюджет для этой задачи:',
    PercentDone: '7p#% сделан#% сделано',
    PermissionsSettingsTitle: 'Права участника {0}',
    project: 'Проект',
    Project_NotFound_Message: 'Проект не найден или у вас отсутствуют права на его просмотр. Проконсультируйтесь с вашим администратором {brandName} для уточнения возможной причины. Id проекта {0}.',
    Project_NotFound_Title: 'Проект не найден',
    Project_WasCompleted_Ok: 'Проект был завершен за <b>{0} до</b> запланированной даты окончания',
    Project_WasCompleted_Trouble: 'Проект был завершен через <b>{0} после</b> запланированной даты окончания',
    Project_WasCompleted_Warning: 'Проект был завершен в день запланированной даты окончания',
    RatioOfMoneySpent: '7p#{0} из {1} потрачен#{0} из {1} потрачено',
    RepeatActivity: 'Повторить',
    request: 'Запрос',
    ResumeWorkHelpText: 'Вы завершили назначенную на вас работу. ',
    ResumeWorkText: 'Возобновить работу',
    RoleTitle: 'Роль в текущем проекте',
    Save: 'Сохранить',
    Set_actualCompletionDate: 'Задайте Факт. Дату Выполнения',
    Set_budget: 'Задайте бюджет',
    set_calendar_description: 'Применение пользовательского календаря пересчитает даты. Вы хотите продолжить?',
    set_calendar_title: 'Изменить календарь на \"{0}\"?',
    Set_calendarId: 'Установить календарь',
    Set_categoryId: 'Задайте категорию',
    Set_customerId: 'Задайте заказчика',
    Set_dates: 'Задайте даты или длительность',
    Set_description: 'Добавить описание',
    Set_endDate: 'Задайте план. дату окончания',
    Set_estimatedHours: 'Задайте расчетные часы',
    Set_hoursLeft: 'Задайте оставшиеся часы',
    Set_labor_budget: 'Задайте бюджет труда',
    Set_portfolioId: 'Задайте портфолио',
    Set_short_hoursLeft: 'Задайте ост. часы',
    SetAsRootLevel: 'Сделать активностью верхнего уровня',
    SetCompleted: 'Пометить как выполненную',
    short_hoursLeft: '7# ч остался# ч осталось# ч осталось',
    show_checklist_label: 'Показать чек-лист',
    ShowCustomFields: 'Показать дополнительные поля',
    Spent: '7p#ч потрачен#ч потрачено',
    Status: 'Статус: ',
    task: 'Задача',
    Task_NotFound_Message: 'Задача не найдена или у вас отсутствуют права на её просмотр. Проконсультируйтесь с вашим администратором {brandName} для уточнения возможной причины. Id задачи {0}.',
    Task_NotFound_Title: 'Задача не найдена',
    Task_WasCompleted_Ok: 'Активность была завершена за <b>{0} до</b> запланированной даты окончания',
    Task_WasCompleted_Trouble: 'Активность была завершена через <b>{0} после</b> запланированной даты окончания',
    Task_WasCompleted_Warning: 'Активность была завершена в день запланированной даты окончания',
    today: 'Сегодня',
    UnFollow: 'Не следить',
    unfollow_all_activities_label: 'Не следить за всеми активностями',
};
